import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
import { msalConfig, loginRequest } from "./authConfig";
import { AccountInfo, InteractionRequiredAuthError } from "@azure/msal-browser";
import { SiteSessionService } from "core/services/SiteSessionService";
import { useStores } from "core/stores";

interface AuthGuardProps {
    children: JSX.Element;
    msalInstance: any;
}

export const AuthGuard = observer((props: AuthGuardProps) => {
    const { accounts } = useMsal();
    const location = useLocation();
    const { userStore } = useStores();

    const [isAccessTokenSet, setIsAccessTokenSet] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        const checkAuthentication = async () => {
            if (SiteSessionService.getAccessToken() == null || SiteSessionService.getAccessToken() == undefined) {
                // Redirect to login if not authenticated
                const account = props.msalInstance.getActiveAccount();

                props.msalInstance
                    .acquireTokenSilent({
                        ...loginRequest,
                        account: account as AccountInfo,
                    })
                    .then((response: any) => {
                        const accessToken = response.accessToken;

                        SiteSessionService.setAccessToken(accessToken);

                        setIsAccessTokenSet(true);

                        userStore.setCurrentUser().then(resp =>{
                            console.log(resp);
                        });
                        //window.location.reload();
                    })
                    .catch((error: any) => {
                        if (error instanceof InteractionRequiredAuthError) {
                            // Trigger an interactive login
                            props.msalInstance
                                .acquireTokenPopup({
                                    scopes: ["user.read"],
                                })
                                .then((response: any) => {
                                    console.log("Token acquired", response);
                                    const accessToken = response.accessToken;

                                    SiteSessionService.setAccessToken(accessToken);
                                    setIsAccessTokenSet(true);
                                    userStore.setCurrentUser();
                                    //window.location.reload();
                                })
                                .catch((err: any) => {
                                    console.error("Interactive login failed", err);
                                });
                        } else {
                            console.error("Silent login failed", error);
                        }
                    });
            } else {
                setIsAccessTokenSet(true);
            }
        };

        checkAuthentication();
    }, [accounts, location]);
    return <>{isAccessTokenSet && <>{props.children}</>}</>;
});
